angular.module('factFindService', []).factory('Client', ['$http', function($http){
  'use strict';
  return {
    get: function() {
      return $http.get('/summary');
    }
  };
}]);
